import React, { useMemo } from 'react';
import { useScopedI18n } from '@locales/client';
import {
  BodyTextRegularB,
  BodyTextMediumA,
  HeadingBoldH5,
} from '@/shared/ui/typography2';
import { BoxCondition, WraperConditions, ConditionItem } from './styles';

export const CONDITION_MAP_KEYS = {
  wager: 'card.wager',
  maxDeposit: 'card.max_deposit',
  minDeposit: 'card.min_deposit',
  maxWin: 'card.max_win',
  maxBet: 'card.max_bet',
  percent: 'card.percent',
  spins: 'card.spins',
  bonusSum: 'card.amount',
  bet: 'card.bet',
};

export const ConditionBlock = React.memo(({ options, conditionActve }) => {
  const t = useScopedI18n('bonus');

  const conditions = useMemo(() => {
    if (!options?.length) return [];

    const targetOption = options.find(
      (el, i) => i === conditionActve || i === options.length - 1
    );
    return targetOption?.conditions || [];
  }, [options, conditionActve]);

  const conditionMap = useMemo(
    () =>
      Object.keys(CONDITION_MAP_KEYS).reduce((acc, key) => {
        acc[key] = t(CONDITION_MAP_KEYS[key]);
        return acc;
      }, {}),
    [t]
  );

  if (!conditions.length) return null;

  return (
    <>
      <HeadingBoldH5>{t('card.terms')}</HeadingBoldH5>
      <WraperConditions>
        {conditions.map(({ label, value }) => (
          <ConditionItem key={label}>
            <BoxCondition>
              <BodyTextRegularB color="#AFAFAF">
                {conditionMap[label] || label}
              </BodyTextRegularB>
              <BodyTextMediumA>{value}</BodyTextMediumA>
            </BoxCondition>
          </ConditionItem>
        ))}
      </WraperConditions>
    </>
  );
});
